import { render } from "./Rol_ModuUsua.vue?vue&type=template&id=eab8f8b8"
import script from "./Rol_ModuUsua.vue?vue&type=script&lang=js"
export * from "./Rol_ModuUsua.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__